<template>
  <div class="head-container">
    <ul class="logo-list">
      <li class="logo"><img :src="''" alt=""></li>
    </ul>
    <ul class="account-list">
      <li class="avatar" @click="avatarClick()">
        <img v-if="form.avatar" :src="form.avatar" alt="">
        <img v-else src="http://yem.oss-cn-shanghai.aliyuncs.com/miror-f/默认头像.png" alt="">
      </li>
      <li>
        <p style="margin-top:12px">{{form.userName}}</p>
      </li>
      <li><el-button type="text" @click="changePassword()">修改密码</el-button></li>
      <li class="power-item" @click="logOut()">
        <svg-icon icon-class="power"></svg-icon>
      </li>
    </ul>
    <el-dialog title="修改密码" :visible.sync="passVisible" top="10vh" :close-on-click-modal="false" width="45%">
      <el-form :model="passForm" ref="passForm" :rules="rules" label-width="100px" size="small">
        <el-row>
          <el-col :span="20">
            <el-form-item label="旧密码：" prop="oldPass">
              <el-input v-model="passForm.oldPass" placeholder="请输入新密码" class="diaInput"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="新密码：" prop="password">
              <el-input v-model="passForm.password" placeholder="请输入新密码" class="diaInput"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="确认密码：" prop="confirmPass">
              <el-input v-model="passForm.confirmPass" placeholder="请再次输入新密码" class="diaInput"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="myPrimary" @click="submitChanePass()">确定</el-button>
        <el-button size="small" type="myCancel" @click="passVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑用户头像" :visible.sync="dialogVisible" top="10vh" :close-on-click-modal="false" width="20%">
      <el-form :model="form" ref="form" label-width="100px" size="small">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="avatar" label-width="120px">
              <el-upload :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="form.avatar" :src="form.avatar" alt="请点击上传头像" class="avater" height="150px" width="150px">
                <img style="display:block;" v-else src="@/assets/image/priAvater.png" alt="">
                <span style="display:block;font-size:12px;">请上传10M以内的图片</span>
                <el-button type="myPrimary" style="width:150px">上传头像</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="登录账号：" prop="account">
              <el-input v-model="form.account" placeholder="请输入账号" class="diaInput" :disabled="disabled"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="员工姓名：" prop="name">
              <el-input v-model="form.nickname" placeholder="请输入姓名" class="diaInput"></el-input>
            </el-form-item> -->
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="myPrimary" @click="submitEdit('form')">确定</el-button>
        <el-button size="small" type="myCancel" @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="preViewTitle" :visible.sync="preViewVisible" top="10vh" center :close-on-click-modal="false" width="30%">
      <div v-html="preViewForm.content" class="preViewContent"></div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="preViewRead">已读，下次登录不再显示此通知</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { myGet, myPost, base_url } from "@/api/http";
export default {
  data() {
    var checkconfirmPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("确认密码不能为空"));
      }
      if (value !== this.passForm.password) {
        callback(new Error("确认密码必须与新密码一致"));
      } else {
        callback();
      }
    };
    return {
      header: {
        Token: sessionStorage.getItem("Token"),
      },
      uploadUrl: base_url + "/auth/fileUpload",
      mailCount: 0,
      name: "",
      avatar: "",
      preViewVisible: false,
      preViewForm: {},
      preViewTitle: "",
      passVisible: false,
      dialogVisible: false,
      passForm: {
        id: "",
        oldPass: "",
        password: "",
        confirmPass: "",
      },
      form: {
        // companyId:"",
        // account: "",
        avatar: "",
        credentials: "",
        diploma: "",
        idCard: "",
        nickname: "",
        // parkId: "",
        // parkIds: [],
        // roleId: "",
        urgencyContent: "",
        urgencyPhone: "",
      },
      rules: {
        oldPass: [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "密码长度在6到16个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "密码长度在6到16个字符",
            trigger: "blur",
          },
        ],
        confirmPass: [
          { required: true, validator: checkconfirmPass, trigger: "blur" },
        ],
        unReadMsgList: [],
      },
    };
  },
  created() {
    this.getUserInfo();
    this.getUnReadMsgList();
  },
  methods: {
    preViewRead() {
      myPost("/crmCrmMessage/user/read/" + this.preViewForm.id).then((res) => {
        this.preViewVisible = false;

        setTimeout(() => {
          if (this.unReadMsgList.length > 0) {
            this.preViewForm = this.unReadMsgList[0];
            this.unReadMsgList.splice(0, 1);

            this.preViewVisible = true;
            this.preViewTitle = this.preViewForm.title;
          }
        }, 100);
      });
    },
    getUnReadMsgList() {
      myGet("/crmCrmMessage/user/unRead/list").then((res) => {
        this.unReadMsgList = [...res.data.data];
        if (this.unReadMsgList.length > 0) {
          this.preViewForm = this.unReadMsgList[0];
          this.unReadMsgList.splice(0, 1);

          this.preViewVisible = true;
          this.preViewTitle = this.preViewForm.title;
        }
      });
    },
    // jump() {
    //   this.$router.push({path:"/sysconfig/notice/"+this.id})
    // },
    getUserInfo() {
      myGet(
        "/auth/userInfo/" + JSON.parse(sessionStorage.getItem("accountInfo")).id
      ).then((res) => {
        // sessionStorage.setItem('accountInfo', JSON.stringify(res.data.data))
        this.form = { ...res.data.data };
      });
    },
    logOut() {
      this.$confirm("是否退出登录?", "提示", {
        confirmButtonClass: "el-button--myPrimary",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出登录成功，请重新登录!",
          });
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出登录",
          });
        });
    },
    avatarClick() {
      this.dialogVisible = true;
    },
    credentialsSuccess(res) {
      this.form.credentials = res.data;
    },
    diplomaSuccess(res) {
      this.form.diploma = res.data;
    },
    handleAvatarSuccess(res, file) {
      this.form.avatar = res.data;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是JPG/PNG格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过1MB!");
      }
      return isJPG && isLt2M;
    },
    changePassword() {
      this.passForm.oldPass = "";
      this.passForm.password = "";
      this.passForm.confirmPass = "";
      this.passVisible = true;
    },
    submitChanePass() {
      this.passForm.id = JSON.parse(sessionStorage.getItem("accountInfo")).id;
      myPost("/auth/userInfo", this.passForm).then((res) => {
        this.$message.success("修改密码成功");
        this.passVisible = false;
      });
    },
    changeInfo() {
      this.getUserInfo();
      this.dialogVisible = true;
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myPost("/auth/avatar/update", this.form).then((res) => {
            this.$message({
              type: "success",
              message: "编辑个人信息成功",
            });
            this.dialogVisible = false;
            this.getUserInfo();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.head-container {
  height: 100%;
  width: 100%;
  /* background-color: #0AAFE7; */
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.account-list {
  height: 40px;
  width: 400px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.parkName {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  padding-left: 25px;
}
.account-list li p {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}
.avatar,
.avatar img {
  height: 36px;
  width: 36px;
}
.avatar {
  border-radius: 50%;
  overflow: hidden;
}
.item {
  height: 40px;
}
.bell-icon {
  margin-top: 7px;
}
.notice {
  padding-right: 15px;
}
.notice,
.avatar,
.power-item {
  cursor: pointer;
}

.logo-list {
  width: 100%;
  height: 100%;
  padding: 0 20px 0 180px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo {
  /* width: 50px; */
  height: 40px;
  overflow: hidden;
  /* background-color: #0AAFE7; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo img {
  height: 35px;
}
</style>

<style>
.el-badge__content.is-fixed {
  position: absolute;
  top: 10px;
  right: 10px;
}
.preViewContent {
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-wrap;
}
/* .head-container .el-button--text {
    color: #333;
  } */
</style>




// WEBPACK FOOTER //
// src/components/layout/navHeader.vue